import { render, staticRenderFns } from "./viewImgList.vue?vue&type=template&id=0f7ed4fe&scoped=true&"
import script from "./viewImgList.vue?vue&type=script&lang=ts&"
export * from "./viewImgList.vue?vue&type=script&lang=ts&"
import style0 from "./viewImgList.vue?vue&type=style&index=0&id=0f7ed4fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ed4fe",
  null
  
)

export default component.exports